<template>
  <div class="sidebar">
    <div class="tools">
      <div class="tool" @mouseenter="showSideBar('pay')" @mouseleave="hideSideBar()">
        <div class="icon"></div>
        <div class="pay-div" v-if="sideBarId == 'pay'">
          <div class="descdiv">
            <label>积分充值</label>
            <span>充积分有折扣，最高5折优惠</span>
            <button @click="showPayVip()">立即充值</button>
          </div>
        </div>
      </div>
      <div class="tool" @mouseenter="showSideBar('task')" @mouseleave="hideSideBar()">
        <div class="icon-border"></div>
        <div class="icon"></div>
        <div class="task-div" v-if="sideBarId == 'task'">
          <div class="descdiv">
            <label>做任务送积分</label>
            <span>邀请好友使用送10积分</span>
            <button title="点击复制" v-clipboard:copy="copytext" v-clipboard:success="copyInviteLink" v-clipboard:error="copyInviteLinkError">立即邀请</button>
            <p title="点击复制" v-clipboard:copy="copytext" v-clipboard:success="copyInviteLink" v-clipboard:error="copyInviteLinkError">点击立即邀请复制邀请链接</p>
            <span class="upload-desc">上传学术集论文送10积分</span>
            <button @click="goPage('learnlist')">立即上传</button>
          </div>
        </div>
      </div>
      <div class="tool" @mouseenter="showSideBar('kefu')" @mouseleave="hideSideBar()">
        <div class="icon-border"></div>
        <div class="icon"></div>
        <div class="kefu-div" v-if="sideBarId == 'kefu'">
          <div class="qrcodediv">
            <p>专属客服</p>
            <img src="/static/img/icon1.jpg" alt="" srcset="">
          </div>
        </div>
      </div>
    </div>
    <v-payvip-popup :isShowPayVip.sync="isShowPayVip" ref="payvip"></v-payvip-popup>
  </div>
</template>

<script>
import PayVipPopup from "../Public/PayVipPopup.vue";
import {
  is_user_login
} from "../../api";
export default {
  name: "sidebar",
  components: {
    "v-payvip-popup": PayVipPopup,
  },
  props: {},
  data() {
    return {
      sideBarId: "",
      isShowPayVip: false,
      copytext:" "
    };
  },
  mounted(){
    is_user_login({is_verify:true}).then((uid) => {
      this.copytext = location.origin+"?f="+uid;
    }).catch((err) => {
      this.copytext = " ";
    });
  },
  methods: {
    showSideBar(sidebar) {
      this.sideBarId = sidebar;
    },
    hideSideBar() {
      this.sideBarId = "";
    },
    isShowPay(flag){
      this.isShowPayVip = flag;
    },
    showPayVip() {
      this.$refs.payvip.getPayGoodsList();
    },
    copyInviteLink(){
      is_user_login({}).then((uid) => {
        this.copytext = location.origin+"?f="+uid;
        this.$message.success("邀请链接复制成功");
      }).catch((err) => {
        this.copytext = " ";
        this.$message.error(err.info);
      });
    },
    copyInviteLinkError(){
      this.$message.error("复制失败");
    },
    goPage(path) {
      is_user_login({}).then((res) => {
        window.location.href = '/'+path;
      }).catch((err) => {
        this.$message.error(err.info);
      });
    }
  },
};
</script>

<style scoped>
.sidebar {
  z-index: 100;
  top: 35%;
  position: fixed;
  width: 50px;
  height: 150px;
  right: 0;
  background: #ffffff;
}
.tools {
  border: 1px solid #efefef;
  width: 100%;
  height: 100%;
}
.tool {
  width: 100%;
  height: 50px;
  cursor: pointer;
}
.icon-border {
  width: 36px;
  margin-left: 7px;
  border-bottom: 1px solid #eeeeee;
}
.icon {
  width: 20px;
  height: 20px;
  float: left;
  margin: 15px;
}
.tool:nth-child(1) > .icon {
  background: url("/static/img/icon_pay.png") no-repeat;
}
.tool:nth-child(1):hover > .icon {
  background: url("/static/img/icon_pay_active.png") no-repeat;
}
.tool:nth-child(2) > .icon {
  background: url("/static/img/icon_task.png") no-repeat;
}
.tool:nth-child(2):hover > .icon {
  background: url("/static/img/icon_task_active.png") no-repeat;
}
.tool:nth-child(3) > .icon {
  background: url("/static/img/icon_kefu.png") no-repeat;
}
.tool:nth-child(3):hover > .icon {
  background: url("/static/img/icon_kefu_active.png") no-repeat;
}

/* 积分充值 */
.pay-div {
  width: 378px;
  height: 100px;
  background: #ffffff;
  box-shadow: 0px 0px 32px 0px rgba(24, 6, 6, 0.32);
  position: relative;
  right: 378px;
}
.descdiv {
  width: 332px;
  float: left;
  position: absolute;
  margin-top: 22px;
  margin-left: 23px;
}
.descdiv label {
  font-size: 16px;
  text-align: left;
  width: 100%;
  float: left;
  color: #031710;
}
.descdiv span {
  font-size: 14px;
  float: left;
  color: #7d8380;
  line-height: 28px;
}
.descdiv button {
  float: right;
  color: #ffffff;
  border: 1px solid #30a263;
  width: 89px;
  height: 30px;
  background: #30a263;
  cursor: pointer;
}

/* 任务列表 */
.task-div {
  width: 378px;
  height: 186px;
  background: #ffffff;
  box-shadow: 0px 0px 32px 0px rgba(24, 6, 6, 0.32);
  position: relative;
  right: 378px;
  bottom: 51px;
}
.descdiv p {
  float: left;
  width: 100%;
  font-size: 12px;
  color: #30a263;
  text-align: left;
  margin-top: 10px;
  margin-bottom: 32px;
}
.upload-desc {
  line-height: 40px;
}

/* 客服二维码 */
.kefu-div {
  width: 229px;
  height: 256px;
  background: #ffffff;
  box-shadow: 0px 0px 32px 0px rgba(24, 6, 6, 0.32);
  position: relative;
  right: 229px;
  bottom: 207px;
}
.qrcodediv {
  width: 100%;
  float: left;
  position: absolute;
  margin-top: 22px;
}
.qrcodediv p {
  margin-top: 5px;
  font-size: 16px;
  color: #031710;
}
.qrcodediv img {
  margin-top: 26px;
  width: 147px;
  height: 147px;
}
</style>



// WEBPACK FOOTER //
// src/components/Public/SideBar.vue